import { CustomToastComponent } from "@/components/shared";
import {
  FillSheetDocument,
  FillSheetMutation,
  FillSheetMutationVariables,
} from "@/graphql/__generated__/graphql";
import { useMutation } from "@apollo/client/react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

/**
 * Custom hook for filling a sheet and handling the necessary cache updates.
 * @returns {Object} - Contains the fillSheetMutation function, loading state, and error state.
 */
export default function useFillSheetMutationHook(): {
  fillSheetMutation: any;
  loading: any;
  error: any;
  } {
  const { t } = useTranslation(["toasts"]);

  const [fillSheetMutation, { loading, error }] = useMutation<
    FillSheetMutation,
    FillSheetMutationVariables
  >(FillSheetDocument, {
    onCompleted() {
      toast(CustomToastComponent, {
        toastId: "fill-sheet-success",
        data: {
          title: t("toasts.sheetagentrunfilledsuccessfully"),
          type: "success",
        },
      });
    },
  });

  return {
    fillSheetMutation,
    loading,
    error,
  };
}
